import './style.scss';

import {
  FloatingFocusManager,
  offset,
  size,
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
} from '@floating-ui/react';
import cn from 'classnames';
import React, { useState } from 'react';

import { useIsDark } from '@/shared/theme';
import { SmartFloatingPortal as FloatingPortal } from '@/shared/ui/SmartFloatingPortal';

import { useTypedDispatch } from 'store';
import { logout } from 'store/slices/auth';

import { ExitIcon, MoreVerticalIcon } from 'assets/icons';

const MoreActionsMenu: React.FC = () => {
  const dispatch = useTypedDispatch();
  const isDark = useIsDark();

  const [isOpened, setIsOpened] = useState<boolean>(false);

  const { refs, context, floatingStyles } = useFloating({
    placement: 'bottom-end',
    open: isOpened,
    onOpenChange: setIsOpened,
    middleware: [
      offset(10),
      size({
        apply({ rects, elements, availableHeight }) {
          Object.assign(elements.floating.style, {
            maxHeight: `${availableHeight}px`,
            minWidth: `${rects.reference.width}px`,
          });
        },
        padding: 10,
      }),
    ],
  });

  const click = useClick(context, { event: 'mousedown' });
  const dismiss = useDismiss(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss, click]);

  return (
    <>
      <button
        className="mm-more-actions-menu-trigger"
        ref={refs.setReference}
        {...getReferenceProps()}
      >
        <MoreVerticalIcon />
      </button>
      {isOpened && (
        <FloatingPortal>
          <FloatingFocusManager context={context} modal={false}>
            <div
              className={cn('mm-more-actions-menu-list', { _is_dark: isDark })}
              ref={refs.setFloating}
              style={floatingStyles}
              {...getFloatingProps()}
            >
              {/* <button
                className="item"
                onClick={() => {
                  dispatch(setTheme(selectedTheme === ETheme.dark ? ETheme.light : ETheme.dark));
                  setIsOpened(false);
                }}
              >
                <RefreshIcon />
                <span>Switch theme</span>
              </button> */}
              <button className="item" onClick={() => dispatch(logout())}>
                <ExitIcon />
                <span>Logout</span>
              </button>
            </div>
          </FloatingFocusManager>
        </FloatingPortal>
      )}
    </>
  );
};

export { MoreActionsMenu };
